/**
 * KIDZWHEELZ — Theme JS Entry Point
 * Compiled by esbuild → assets/theme.js
 * GSAP, ScrollTrigger, and Lenis are loaded as separate globals
 * (assets/gsap.min.js, assets/ScrollTrigger.min.js, assets/lenis.min.js)
 * and must appear before this script in theme.liquid.
 */

import { onReady } from './utils.js';
import { initLenis } from './lenis-init.js';
import { initGSAP } from './gsap-scenes.js';
import { initCartDrawer } from './cart-drawer.js';
import { initProductGallery } from './product-gallery.js';

onReady(() => {
  initGSAP();       /* Register plugins first */
  initLenis();      /* Smooth scroll (syncs with GSAP ticker) */
  initCartDrawer();
  initProductGallery();
});
